import { AutoPaySetupStatus, TerminalStatus, TerminalStatusContext } from '../../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../../components/execution/terminal/AllStatusWrapper'
import { useEffect, useState } from 'react'
import { useAutoPayStatusQuery } from '../../../../hooks/mf-execution/useAutoPayStatusQuery'
import { postCTA } from '../../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../../utils/mutualFundDetail'

export const AutoPayStatusPage = () => {
  const [status, setStatus] = useState<TerminalStatus>(TerminalStatus.LOADING)
  const { autoPayStatus, isLoading, isError, isExpired } = useAutoPayStatusQuery()

  useEffect(() => {
    if (isError || autoPayStatus?.status === AutoPaySetupStatus.FAILED) {
      setStatus(TerminalStatus.FAILURE)
    } else if (autoPayStatus?.status === AutoPaySetupStatus.SUCCESS) {
      setStatus(TerminalStatus.PARTIAL_SUCCESS)
      setTimeout(() => {
        setStatus(TerminalStatus.FULL_SUCCESS)
      }, 2000)
    } else if (autoPayStatus?.status === AutoPaySetupStatus.INITIATED || isLoading) {
      setStatus(TerminalStatus.LOADING)
    }
  }, [autoPayStatus, isLoading, isError])

  useEffect(() => {
    if (isExpired && status === TerminalStatus.LOADING) {
      setStatus(TerminalStatus.PENDING)
    }
  }, [isExpired, status])

  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={status}
        statusContext={TerminalStatusContext.AUTO_PAY}
        loadingConfig={{
          title: 'Setting up your SIP'
        }}
        partialSuccessConfig={{
          title: 'Autopay setup <br /> completed'
        }}
        fullSuccessConfig={{
          title: 'Your SIP is all set',
          caption: 'Your Autopay activation request will be <br /> processed in 3-4 working days.',
          ctas: [
            {
              ctaType: 'secondary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
        failureConfig={{
          title: 'Autopay setup failed',
          caption: 'We couldn’t place your Autopay setup request at the moment.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Close',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
        pendingConfig={{
          title: 'Autopay setup pending',
          caption: 'It’s taking longer than expected. We’ll <br /> notify you once your SIP is set.',
          ctas: [
            {
              ctaType: 'primary',
              label: 'Close',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}
